import React, { useEffect } from 'react';
import { ButtonTooltip } from '../../Utils/Tooltips';
import Icon from '../../Icons';

const BirthsModalButtons = ({ show, onHide, onPrevMonth, onNextMonth, onCurrentMonth, showMonthControls }) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        onHide();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [show, onHide]);

  return (
    <div className="d-flex align-items-center justify-content-center w-100 mt-2">
      {showMonthControls && (
        <>
          <ButtonTooltip
            onClick={onPrevMonth}
            variant="circle-info"
            className="btn-circle mr-2"
            toolbarVariant="my-3"
            size="sm"
            text="Mes anterior"
          >
            <Icon icon="chevron-back" />
          </ButtonTooltip>
          <button type="button" className="btn btn-outline-primary btn-sm mr-2" onClick={onCurrentMonth}>
            Ir al Mes Actual
          </button>
          <ButtonTooltip
            onClick={onNextMonth}
            variant="circle-info"
            className="btn-circle mr-2"
            toolbarVariant="my-3"
            size="sm"
            text="Mes siguiente"
          >
            <Icon icon="chevron-forward" />
          </ButtonTooltip>
        </>
      )}
    </div>
  );
};

export default BirthsModalButtons;
